// extracted by mini-css-extract-plugin
module.exports = {"image":"GatherersTavernAd_image__4DqEh"};